import { Outlet } from 'react-router-dom';
import Navbar from './Navbar';
import Footer from './Footer';
import ExitClickTracker from './ExitClickTracker';
import PageViewTracker from './PageViewTracker';

export default function Layout() {
  return (
    <div className="public-layout min-h-screen flex flex-col bg-cdi-blue">
      <ExitClickTracker />
      <PageViewTracker />
      <Navbar />
      <main className="flex-1 bg-cdi-canvas">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}
